import styles from '@components/components/CmsComponents/components/CmsBlogCategory/CmsBlogCategory.module.scss';
import { BlogCard, Button, Link } from '@wienenergiegithub/ui-next';
import React, { useState } from 'react';

const CmsBlogCategory = ({ headingLevel, items, link, numberToShow }) => {
  const [recentsToShow, setRecentsToShow] = useState(numberToShow);
  const showMore = () => setRecentsToShow(prev => prev + 4);
  return (
    <>
      <div className={styles.container}>
        {items?.slice(0, recentsToShow)?.map(item => (
          <BlogCard
            {...item}
            headingLevel={headingLevel}
            key={`${item?.title}`}
            link={`${item?.link}?type=business`}
          />
        ))}
      </div>
      {items?.length > recentsToShow && (
        <div className={styles.action}>
          <Button onClick={showMore} theme="primary" variant="outline">
            Mehr anzeigen
          </Button>
        </div>
      )}
      {link?.url && (
        <div className={styles.buttonContainer}>
          <Button
            render={<Link to={link?.url} />}
            theme="primary"
            variant="outline"
          >
            {link?.title}
          </Button>
        </div>
      )}
    </>
  );
};
export default CmsBlogCategory;
